var _g, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRefreshDisabled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-refresh-disabled_svg__filter0_d_3620_60516)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 19,
    r: 15,
    fill: "#D3DCE6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.45 11.342c0-.36-.003-.672.001-.984a1 1 0 011.012-1.01.971.971 0 01.992.975c.016 1.235.017 2.47.01 3.705-.002.495-.437.927-.936.934-1.219.016-2.439.025-3.659.02-.554-.001-.953-.377-1.017-.909-.054-.45.263-.947.724-1.046.294-.063.605-.044.91-.055.225-.007.45 0 .703-.049-.065-.058-.126-.12-.195-.172-1.686-1.325-3.607-1.896-5.736-1.715-3.54.299-6.48 2.995-7.124 6.493-.803 4.364 2.043 8.528 6.388 9.345 4.295.808 8.499-2.03 9.33-6.302a7.766 7.766 0 00.114-2.307c-.077-.744.352-1.25 1.025-1.236.511.01.93.398.97.932.29 3.873-1.12 6.979-4.267 9.261-1.39 1.01-2.977 1.552-4.69 1.727-4.944.503-9.628-2.742-10.766-7.8-1.212-5.39 2.312-10.851 7.746-11.933 3.06-.61 5.84.076 8.304 2.004.041.033.084.064.161.122z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-refresh-disabled_svg__filter0_d_3620_60516",
    x: 0,
    y: 0,
    width: 38,
    height: 38,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3620_60516"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_3620_60516",
    result: "shape"
  })))));
}

export default SvgIconRefreshDisabled;